var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4123 17.8781L17.1373 20.8781C17.7466 21.2625 18.4966 20.6906 18.3185 19.9875L16.9498 14.6063C16.9127 14.4571 16.9186 14.3005 16.9667 14.1546C17.0148 14.0086 17.1032 13.8792 17.2216 13.7813L21.4591 10.2469C22.0123 9.78752 21.731 8.8594 21.0091 8.81252L15.4779 8.45627C15.327 8.44749 15.1819 8.39494 15.0603 8.30503C14.9388 8.21513 14.8461 8.09177 14.7935 7.95002L12.731 2.75627C12.6764 2.60618 12.5769 2.47653 12.4461 2.38491C12.3153 2.29329 12.1595 2.24414 11.9998 2.24414C11.84 2.24414 11.6842 2.29329 11.5534 2.38491C11.4226 2.47653 11.3231 2.60618 11.2685 2.75627L9.206 7.95002C9.15344 8.09177 9.06072 8.21513 8.93918 8.30503C8.81764 8.39494 8.67255 8.44749 8.52163 8.45627L2.99038 8.81252C2.2685 8.8594 1.98725 9.78752 2.54038 10.2469L6.77788 13.7813C6.89632 13.8792 6.98468 14.0086 7.03278 14.1546C7.08088 14.3005 7.08676 14.4571 7.04975 14.6063L5.78413 19.5938C5.5685 20.4375 6.4685 21.1219 7.19038 20.6625L11.5873 17.8781C11.7105 17.7997 11.8536 17.7581 11.9998 17.7581C12.1459 17.7581 12.289 17.7997 12.4123 17.8781V17.8781Z",
    stroke: "#FFCC00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.be2d170116b40a08d6d79e9313fd9a28.svg";
export { ForwardRef as ReactComponent };